import { render, staticRenderFns } from "./auth-register.vue?vue&type=template&id=27a79c14&"
import script from "./auth-register.vue?vue&type=script&lang=js&"
export * from "./auth-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports